module.exports = __webpack_public_path__ + "static/media/ten_percent.b78e616b.png";